<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage purchase order</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="purchasesLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loadig purchases...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemPurchases"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'Action'">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm btn-rounded purchaseorder_id"
                        @click="viewPurchases(props.row.id)"
                      >
                        <i class="fa fa-plus"></i> print order
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Purchase no",
          field: "purchase_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
           
          },
        },
        {
          label: "Purchase date",
          field: "purchase_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", 
          filterOptions: {
            enabled: true, // enable filter for this column
           
          },// outputs Mar 16th 2018
        },
        {
          label: "Grand total",
          field: "purchase_total",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
           
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
           
          },
        },
      ],
    };
  },
  created() {
    this.loadPurchases();
  },
  computed: {
    ...mapGetters(["systemPurchases"]),
  },
  methods: {
    ...mapActions(["loadPurchases", "viewPurchases"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/purchases/managepurchases.vue